import axios from "axios";
import { APIURL } from "../Constantes";
import { getCabecera } from "../utils/getCabecera";
import {getError} from "../utils/errors"
const urlSupport = "Support";
// * Metodo para actulizar fecha de salida
export const putFechaSalidaReferenciaCustom = async ({ Referencia, FechaSalida, MontoUnitario}) => {
    return axios.put(`${APIURL}/${urlSupport}/TravelDate/Agent/Custom/${Referencia}`, {
            "FechaSalida": FechaSalida,
            "MontoUnitario": MontoUnitario
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error)
        })
}
// * Metodo para agregar un item a una referencia
export const putAddItemCustom = async ({ Referencia, Nombre, Descripcion, MontoUnitario}) => {
    return axios.put(`${APIURL}/${urlSupport}/Extra/Custom/${Referencia}`, {
            "Nombre": Nombre,
            "Descripcion": Descripcion,
            "MontoUnitario": MontoUnitario
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error)
        })
}